export const FROM_PLACEHOLDER ="Enter Source";
export const TO_PLACEHOLDER = "Enter Destination";
export const RATING_REVIEW_SHOW_COUNT = 2;
